export default "__VITE_ASSET__BpBAZkwO__"